import { captureException } from '@sentry/react';

import { fetch } from './fetch';
import { urls } from '@zapier/identity-utils';
import { removeStoredAuthType } from '../hooks';

/**
 * Log the user out
 */
export async function logout() {
  removeStoredAuthType();

  try {
    return await fetch(urls.LOGOUT_API_URL, {
      headers: {
        Accept: 'application/json',
      },
      // Callers often navigate away in the same tick (e.g. the "Back to login"
      // link), which would otherwise cancel this request and leave the session
      // alive server-side. `keepalive` lets it outlive the page.
      keepalive: true,
    });
  } catch (error) {
    // This `fetch` drops the authenticationError middleware and `responseBody`
    // swallows parse failures, so a rejection here is a genuine transport
    // failure rather than an expected 401 — and it means the session is still
    // alive server-side. The fire-and-forget caller cannot surface that, so
    // report it before re-throwing for the callers that do await.
    captureException(error);
    throw error;
  }
}
